module.exports = {
    abbreviations_uid: 7642,
    abbreviations_tokenid: 'uMEWAty2Ma26nZnh'
}